/**
 * @generated SignedSource<<15e0c65e2194f168fd92b66c44e9533d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LikesScreenQuery$variables = Record<PropertyKey, never>;
export type LikesScreenQuery$data = {
  readonly currentUser: {
    readonly isPlus: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"LikesListFree_user" | "LikesList_user">;
  } | null | undefined;
};
export type LikesScreenQuery = {
  response: LikesScreenQuery$data;
  variables: LikesScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPlus",
  "storageKey": null
},
v1 = {
  "kind": "Literal",
  "name": "filter",
  "value": {
    "fromUser": {
      "status": {
        "equalTo": "ACTIVE"
      }
    }
  }
},
v2 = {
  "kind": "Literal",
  "name": "first",
  "value": 20
},
v3 = [
  (v1/*:: as any*/),
  (v2/*:: as any*/),
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": [
      "IS_SPARK_DESC",
      "SPARKED_AT_DESC",
      "ROW_ID_DESC"
    ]
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSpark",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sparkedAt",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Profile",
  "kind": "LinkedField",
  "name": "profile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Photo",
      "kind": "LinkedField",
      "name": "headshot",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StorageObject",
          "kind": "LinkedField",
          "name": "storageObject",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "blurhash",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "bucket",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "key",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v9/*:: as any*/)
      ],
      "storageKey": null
    },
    (v9/*:: as any*/)
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewedAt",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = [
  "filter",
  "orderBy"
],
v15 = [
  (v1/*:: as any*/),
  (v2/*:: as any*/),
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": [
      "IS_SPARK_DESC",
      "SPARKED_AT_DESC",
      "ROW_ID_ASC"
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "LikesScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LikesList_user"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LikesListFree_user"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "LikesScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": (v3/*:: as any*/),
            "concreteType": "LikeConnection",
            "kind": "LinkedField",
            "name": "likes",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LikeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  (v4/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Like",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*:: as any*/),
                      (v6/*:: as any*/),
                      (v7/*:: as any*/),
                      (v8/*:: as any*/),
                      (v10/*:: as any*/),
                      (v11/*:: as any*/),
                      (v9/*:: as any*/),
                      (v12/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v13/*:: as any*/),
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__id",
                    "storageKey": null
                  }
                ]
              }
            ],
            "storageKey": "likes(filter:{\"fromUser\":{\"status\":{\"equalTo\":\"ACTIVE\"}}},first:20,orderBy:[\"IS_SPARK_DESC\",\"SPARKED_AT_DESC\",\"ROW_ID_DESC\"])"
          },
          {
            "alias": null,
            "args": (v3/*:: as any*/),
            "filters": (v14/*:: as any*/),
            "handle": "connection",
            "key": "LikesList_user_likes",
            "kind": "LinkedHandle",
            "name": "likes"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unviewedLikesCount",
            "storageKey": null
          },
          (v9/*:: as any*/),
          {
            "alias": "freeLikes",
            "args": (v15/*:: as any*/),
            "concreteType": "LikeConnection",
            "kind": "LinkedField",
            "name": "likes",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LikeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  (v4/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Like",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      (v5/*:: as any*/),
                      (v7/*:: as any*/),
                      (v8/*:: as any*/),
                      (v10/*:: as any*/),
                      (v11/*:: as any*/),
                      (v9/*:: as any*/),
                      (v12/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v13/*:: as any*/)
            ],
            "storageKey": "likes(filter:{\"fromUser\":{\"status\":{\"equalTo\":\"ACTIVE\"}}},first:20,orderBy:[\"IS_SPARK_DESC\",\"SPARKED_AT_DESC\",\"ROW_ID_ASC\"])"
          },
          {
            "alias": "freeLikes",
            "args": (v15/*:: as any*/),
            "filters": (v14/*:: as any*/),
            "handle": "connection",
            "key": "LikesListFree_user_freeLikes",
            "kind": "LinkedHandle",
            "name": "likes"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7fe51c992d72de08a63df18d895a2e73",
    "id": null,
    "metadata": {},
    "name": "LikesScreenQuery",
    "operationKind": "query",
    "text": "query LikesScreenQuery {\n  currentUser {\n    isPlus\n    ...LikesList_user\n    ...LikesListFree_user\n    id\n  }\n}\n\nfragment LikesListFree_user on User {\n  freeLikes: likes(first: 20, filter: {fromUser: {status: {equalTo: ACTIVE}}}, orderBy: [IS_SPARK_DESC, SPARKED_AT_DESC, ROW_ID_ASC]) {\n    edges {\n      cursor\n      node {\n        isSpark\n        ...LikesListItem_like\n        ...LikesListItemFree_like\n        id\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  unviewedLikesCount\n  id\n}\n\nfragment LikesListItemFree_like on Like {\n  createdAt\n}\n\nfragment LikesListItem_like on Like {\n  createdAt\n  isSpark\n  rowId\n  sparkedAt\n  profile {\n    name\n    ...ProfileListItem_profile\n    id\n  }\n  viewedAt\n}\n\nfragment LikesList_user on User {\n  likes(first: 20, filter: {fromUser: {status: {equalTo: ACTIVE}}}, orderBy: [IS_SPARK_DESC, SPARKED_AT_DESC, ROW_ID_DESC]) {\n    edges {\n      cursor\n      node {\n        ...LikesListItem_like\n        id\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  unviewedLikesCount\n  id\n}\n\nfragment ProfileAvatar_profile on Profile {\n  headshot {\n    storageObject {\n      blurhash\n      bucket\n      key\n    }\n    id\n  }\n  name\n}\n\nfragment ProfileListItem_profile on Profile {\n  name\n  ...ProfileAvatar_profile\n}\n"
  }
};
})();

(node as any).hash = "02ef090d0a8464ee1323b3a69ba0dfa3";

export default node;
